import { render } from "./RestaurantFloor.vue?vue&type=template&id=0b814c66&scoped=true"
import script from "./RestaurantFloor.vue?vue&type=script&lang=js"
export * from "./RestaurantFloor.vue?vue&type=script&lang=js"

import "./RestaurantFloor.vue?vue&type=style&index=0&id=0b814c66&scoped=true&lang=css"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b814c66"]])

export default __exports__